import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/fns/nft-sm.jpg';
import _imports_1 from '@/assets/images/fns/nft-lg.jpg';
import _imports_2 from '@/assets/images/fns/show_1_sm.png';
import _imports_3 from '@/assets/images/fns/show_1_lg.png';
import _imports_4 from '@/assets/images/fns/envs_sm.png';
import _imports_5 from '@/assets/images/fns/envs_lg.jpg';
import _imports_6 from '@/assets/images/icons/dashbord.png';
import _imports_7 from '@/assets/images/icons/computer-greep.svg';
import _imports_8 from '@/assets/images/icons/tip.svg';
import _imports_9 from '@/assets/images/icons/fil.svg';
import _imports_10 from '@/assets/images/icons/open.svg';
const _withScopeId = n => (_pushScopeId("data-v-6fcd49e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = _imports_0;
const _hoisted_2 = _imports_2;
const _hoisted_3 = _imports_4;
const _hoisted_4 = {
  class: "container"
};
const _hoisted_5 = {
  class: "row mb-3"
};
const _hoisted_6 = {
  class: "col-12"
};
const _hoisted_7 = {
  class: "top-show position-relative"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  media: "(max-width: 991px)",
  srcset: _hoisted_1
}, null, -1));
const _hoisted_9 = {
  ref: "firstImg",
  style: {
    "width": "100%",
    "border-radius": "10px"
  },
  src: _imports_1,
  alt: "stfil.io"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://app.fns.space?referCode=2SYswMuf6jC9vVUBWc8U9LVZh92r",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("picture", null, [/*#__PURE__*/_createElementVNode("source", {
  media: "(max-width: 991px)",
  srcset: _hoisted_2
}), /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "100%",
    "border-radius": "10px"
  },
  src: _imports_3,
  alt: "fns.space"
})])], -1));
const _hoisted_11 = ["href"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("picture", null, [/*#__PURE__*/_createElementVNode("source", {
  media: "(max-width: 991px)",
  srcset: _hoisted_3
}), /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "100%",
    "border-radius": "10px"
  },
  src: _imports_5,
  alt: "vens"
})], -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {
    "width": "28px",
    "height": "28px"
  },
  class: "mr-2",
  alt: ""
}, null, -1));
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "fw-medium fsi-16 mr-2",
  style: {
    "color": "#3d3d3d"
  }
};
const _hoisted_17 = {
  class: "fw-bold fsi-16"
};
const _hoisted_18 = {
  class: "row mt-4"
};
const _hoisted_19 = {
  class: "col-12"
};
const _hoisted_20 = {
  class: "row"
};
const _hoisted_21 = {
  class: "col-12"
};
const _hoisted_22 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-20 dashboard-card"
};
const _hoisted_23 = {
  class: "d-flex flex-row mb-3 mt-1"
};
const _hoisted_24 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_26 = {
  class: "mb-sm-3 mb-2"
};
const _hoisted_27 = {
  class: "row"
};
const _hoisted_28 = {
  class: "col-lg-3 col-md-6 col-12"
};
const _hoisted_29 = {
  class: "fw-medium fsi-14 subheading-text d-flex align-items-center"
};
const _hoisted_30 = {
  class: "mr-1"
};
const _hoisted_31 = {
  key: 0,
  class: "fs-12"
};
const _hoisted_32 = {
  class: "fw-extra-bold text-primary"
};
const _hoisted_33 = {
  class: "fw-extra-bold fsi-30 text-primary d-flex align-items-center"
};
const _hoisted_34 = {
  class: "fsi-14 d-flex align-items-center mb-md-0 mb-3",
  style: {
    "margin-top": "-2px",
    "line-height": "1.6"
  }
};
const _hoisted_35 = {
  class: "mr-1"
};
const _hoisted_36 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_37 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-12 mt-md-0 mt-2"
};
const _hoisted_38 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_39 = {
  key: 0,
  class: "fs-12"
};
const _hoisted_40 = {
  class: "fw-bold"
};
const _hoisted_41 = {
  key: 0,
  class: "fs-12"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#dedede"
  },
  class: "mt-2 mb-3"
}, null, -1));
const _hoisted_43 = {
  class: "d-flex justify-content-between align-content-center mt-1"
};
const _hoisted_44 = {
  class: "d-flex justify-content-between align-content-center mt-1"
};
const _hoisted_45 = {
  class: "d-flex justify-content-between align-content-center mt-1"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "20px",
    "margin-bottom": "3px",
    "cursor": "pointer",
    "transform": "translateY(0px)"
  },
  src: _imports_8,
  alt: ""
}, null, -1));
const _hoisted_47 = {
  class: "fw-extra-bold text-primary"
};
const _hoisted_48 = {
  class: "fw-extra-bold fsi-30",
  style: {
    "color": "#00CE92"
  }
};
const _hoisted_49 = {
  class: "fsi-14 d-flex align-items-center justify-content-start"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "",
  style: {
    "width": "18px"
  }
}, null, -1));
const _hoisted_51 = {
  class: "row mb-4"
};
const _hoisted_52 = {
  class: "col-12"
};
const _hoisted_53 = {
  class: "row"
};
const _hoisted_54 = {
  class: "col-lg-3 col-md-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_55 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "2px",
    "cursor": "pointer"
  },
  src: _imports_10,
  alt: ""
}, null, -1));
const _hoisted_57 = [_hoisted_56];
const _hoisted_58 = {
  class: "fw-bold fsi-18"
};
const _hoisted_59 = {
  class: "fw-medium fsi-14"
};
const _hoisted_60 = {
  class: "fw-bold fsi-18"
};
const _hoisted_61 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_62 = {
  class: "col-lg-3 col-md-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_63 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_64 = {
  class: "fw-bold fsi-18"
};
const _hoisted_65 = {
  class: "fw-medium fsi-14"
};
const _hoisted_66 = {
  class: "fw-bold fsi-18"
};
const _hoisted_67 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_68 = {
  class: "col-lg-3 col-md-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_69 = {
  class: "fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_70 = {
  class: "mr-1 subheading-text"
};
const _hoisted_71 = {
  class: "fw-bold fsi-18"
};
const _hoisted_72 = {
  class: "fw-bold fsi-18 d-flex align-items-center"
};
const _hoisted_73 = {
  class: "col-lg-3 col-md-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_74 = {
  class: "fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_75 = {
  class: "mr-1 subheading-text"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "2px",
    "cursor": "pointer"
  },
  src: _imports_10,
  alt: ""
}, null, -1));
const _hoisted_77 = [_hoisted_76];
const _hoisted_78 = {
  class: "fw-bold fsi-18"
};
const _hoisted_79 = {
  class: "fw-bold fsi-18 d-flex align-items-center"
};
const _hoisted_80 = {
  class: ""
};
const _hoisted_81 = {
  class: "d-flex mb-2 justify-content-between"
};
const _hoisted_82 = {
  class: "fsi-14",
  style: {
    "position": "relative",
    "height": "24px"
  }
};
const _hoisted_83 = {
  style: {
    "transition": "0.6s ease-out"
  }
};
const _hoisted_84 = {
  class: "d-none d-lg-block fsi-14",
  style: {
    "position": "relative",
    "height": "24px"
  }
};
const _hoisted_85 = {
  class: "position-relative mb-2"
};
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "borrow-progress-bar"
}, null, -1));
const _hoisted_87 = {
  class: "row mt-4"
};
const _hoisted_88 = {
  class: "col-12"
};
const _hoisted_89 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-20 dashboard-card"
};
const _hoisted_90 = {
  class: "d-flex flex-row mb-3 mt-1"
};
const _hoisted_91 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_93 = {
  class: "row mb-3"
};
const _hoisted_94 = {
  class: "col-lg-3 col-md-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_95 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_96 = {
  class: "fw-bold fsi-18"
};
const _hoisted_97 = {
  class: "fw-medium fsi-14"
};
const _hoisted_98 = {
  class: "fw-bold fsi-18"
};
const _hoisted_99 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_100 = {
  class: "col-lg-3 col-md-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_101 = {
  class: "fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_102 = {
  class: "mr-1 subheading-text"
};
const _hoisted_103 = {
  class: "fw-bold fsi-18"
};
const _hoisted_104 = {
  class: "fw-medium fsi-14"
};
const _hoisted_105 = {
  class: "fw-bold fsi-18"
};
const _hoisted_106 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_107 = {
  class: "row"
};
const _hoisted_108 = {
  class: "col-12"
};
const _hoisted_109 = {
  class: "row mt-4"
};
const _hoisted_110 = {
  class: "col-12"
};
const _hoisted_111 = {
  class: "row mt-4"
};
const _hoisted_112 = {
  class: "col-xl-6 col-12"
};
const _hoisted_113 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-20 dashboard-card"
};
const _hoisted_114 = {
  class: "d-flex flex-row mb-3 mt-1"
};
const _hoisted_115 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_116 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_117 = {
  class: "d-block d-sm-flex mb-4"
};
const _hoisted_118 = {
  class: "mr-md-5 mr-4"
};
const _hoisted_119 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_120 = {
  class: "fw-bold fsi-18"
};
const _hoisted_121 = {
  class: "fw-medium fsi-14"
};
const _hoisted_122 = {
  class: "fw-bold fsi-18"
};
const _hoisted_123 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_124 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-none d-sm-block vertical-dividing-line mr-4"
}, null, -1));
const _hoisted_125 = {
  class: "mr-5 mt-3 mt-sm-0"
};
const _hoisted_126 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_127 = {
  class: "fw-bold fsi-18"
};
const _hoisted_128 = {
  class: "fw-medium fsi-14"
};
const _hoisted_129 = {
  class: "fw-bold fsi-18"
};
const _hoisted_130 = {
  key: 0,
  class: "fw-medium fsi-14"
};
const _hoisted_131 = {
  class: "col-xl-6 col-12 mt-xl-0 mt-4"
};
const _hoisted_132 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-20 dashboard-card h-100"
};
const _hoisted_133 = {
  class: "d-flex flex-row mb-3 mt-1"
};
const _hoisted_134 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_135 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_136 = {
  class: "d-flex mb-4"
};
const _hoisted_137 = {
  class: "mr-5"
};
const _hoisted_138 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_139 = {
  class: "fw-bold fsi-18"
};
const _hoisted_140 = {
  class: "fw-bold fsi-18"
};
const _hoisted_141 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "vertical-dividing-line mr-4"
}, null, -1));
const _hoisted_142 = {
  class: "mr-5"
};
const _hoisted_143 = {
  class: "fw-medium fsi-14 subheading-text"
};
const _hoisted_144 = {
  class: "fw-bold fsi-18"
};
const _hoisted_145 = {
  class: "fw-bold fsi-18"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_el_carousel = _resolveComponent("el-carousel");
  const _component_PageHead = _resolveComponent("PageHead");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_ScrollNumber = _resolveComponent("ScrollNumber");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_chart_block = _resolveComponent("chart-block");
  const _component_StakeLeftChart = _resolveComponent("StakeLeftChart");
  const _component_AdCard = _resolveComponent("AdCard");
  return _openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_carousel, {
    height: _ctx.screenHeight,
    "indicator-position": "none",
    interval: 5000
  }, {
    default: _withCtx(() => [_createVNode(_component_el_carousel_item, null, {
      default: _withCtx(() => [_createVNode(_component_router_link, {
        to: "referrals"
      }, {
        default: _withCtx(() => [_createElementVNode("picture", null, [_hoisted_8, _createElementVNode("img", _hoisted_9, null, 512)])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_carousel_item, null, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }), _createVNode(_component_el_carousel_item, null, {
      default: _withCtx(() => [_createElementVNode("a", {
        href: `https://venus.filecoin.io/${_ctx.$i18n.locale === 'zh' ? 'zh/' : ''}`,
        target: "_blank"
      }, _hoisted_13, 8, _hoisted_11)]),
      _: 1
    })]),
    _: 1
  }, 8, ["height"])])])]), _createElementVNode("div", null, [_createVNode(_component_PageHead, {
    content: _ctx.$t('dashboard.Introduction')
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('dashboard.Dashboard')), 1)]),
    icon: _withCtx(() => [_hoisted_14]),
    "title-right-tool": _withCtx(() => [_ctx.filPrice !== '0.00' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('common.CurrentFILPrice')), 1), _createElementVNode("span", _hoisted_17, "$" + _toDisplayString(_ctx.filPrice), 1)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["content"]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('common.Overview')), 1), _hoisted_25]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createTextVNode(_toDisplayString(_ctx.$t('stake.NetAPY')), 1), _ctx.$i18n.locale === 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('stake.APY')), 1)) : _createCommentVNode("", true)]), _createVNode(_component_Tooltip, {
    style: {
      "transform": "translateY(2px)"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('stake.NetAPYTip')) + " ", 1), _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = (...args) => $options.gotNetAPYTip && $options.gotNetAPYTip(...args)),
      class: "link-text"
    }, _toDisplayString(_ctx.$t('stake.LearnMore')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('dashboard.ReserveFactorTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.reserveDataLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "42px"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "18px",
        "font-size": "14px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_ScrollNumber, {
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "%",
      number: $options.formatPrice($options.formatUnits(_ctx.liquidityRate, 25), 2),
      h: 30
    }, null, 8, ["number"]), _createElementVNode("img", {
      onClick: _cache[1] || (_cache[1] = (...args) => $options.showComputer && $options.showComputer(...args)),
      class: "cursor-pointer computer-css",
      src: _imports_7,
      style: {
        "width": "26px"
      },
      alt: ""
    })]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createTextVNode(_toDisplayString(_ctx.$t('common.Convert to APR')), 1), _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('common.APR')), 1)]), _createElementVNode("div", null, [_createVNode(_component_ScrollNumber, {
      unit: "%",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 0'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      number: _ctx.liquidityRateApr,
      h: 14
    }, null, 8, ["customSignStyle", "number"])])])]),
    _: 1
  }, 8, ["loading"])]), _ctx.tvl !== 0 && _ctx.tvl !== undefined && _ctx.tvl !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createTextVNode(_toDisplayString(_ctx.$t('dashboard.TVL')), 1), _ctx.$i18n.locale === 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('dashboard.STVL')), 1)) : _createCommentVNode("", true), _createVNode(_component_el_popover, {
    placement: "bottom",
    width: 300,
    trigger: "click"
  }, {
    reference: _withCtx(() => [_hoisted_46]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_40, [_createTextVNode(_toDisplayString(_ctx.$t('dashboard.TotalValueLocked')), 1), _ctx.$i18n.locale === 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('dashboard.STVL')), 1)) : _createCommentVNode("", true)]), _hoisted_42, _createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('dashboard.AvailableLiquidity')) + ":", 1), _createElementVNode("div", null, "$" + _toDisplayString($options.formatPriceToMaxFixed(_ctx.tvlPoolStFilBalanceUsd, 2, true)), 1)]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('dashboard.FarmBalance')) + ":", 1), _createElementVNode("div", null, "$" + _toDisplayString($options.formatPriceToMaxFixed(_ctx.tvlAllMinerValueUsd, 2, true)), 1)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('subpool.withdrawLoadAmount')) + ":", 1), _createElementVNode("div", null, "$" + _toDisplayString($options.formatPriceToMaxFixed(_ctx.tvlWithdrawLoadAmountUsd, 2, true)), 1)])])]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.tvlLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "42px",
        "font-size": "30px"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "18px",
        "font-size": "14px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createVNode(_component_ScrollNumber, {
      prefix: "$",
      style: {
        "line-height": "1.6"
      },
      "prefix-style": {
        margin: '0 1px 0 0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      number: $options.formatPriceToMaxFixed(_ctx.tvl, 2, true),
      h: 30
    }, null, 8, ["number"])]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createVNode(_component_ScrollNumber, {
      style: {
        "line-height": "1"
      },
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: "",
      number: $options.externalFormatFilPrice(_ctx.tvlFIL, 2, true, false),
      h: 14
    }, null, 8, ["customSignStyle", "number"])])]),
    _: 1
  }, 8, ["loading"])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createTextVNode(_toDisplayString(_ctx.$t('dashboard.AvailableLiquidity')) + " ", 1), _createElementVNode("span", {
    style: {
      "margin-left": "3px"
    },
    onClick: _cache[2] || (_cache[2] = (...args) => $options.openAvailableliquidity && $options.openAvailableliquidity(...args))
  }, _hoisted_57)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolStFilBalanceLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })]), _createElementVNode("div", _hoisted_59, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_60, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.formatWalletFilPrice(_ctx.poolStFilBalanceBig, 2, true, false, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.poolStFilBalanceBigObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-sub-title",
      prefix: "$",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.poolStFilBalanceBigObj.suffix,
      number: _ctx.poolStFilBalanceBigObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('dashboard.Total Collateral Automated')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.tvlLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })]), _createElementVNode("div", _hoisted_65, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.externalFormatFilPrice(_ctx.tvlAllMinerValue, 2, true, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.tvlAllMinerValueBigObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-sub-title",
      prefix: "$",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.tvlAllMinerValueBigObj.suffix,
      number: _ctx.tvlAllMinerValueBigObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('dashboard.nodes')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.tvlLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_72, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      customStyle: {
        margin: '0'
      },
      color: "",
      number: _ctx.nodeCount,
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createTextVNode(_toDisplayString(_ctx.$t('dashboard.Stakers')) + " ", 1), _createElementVNode("span", {
    style: {
      "margin-left": "3px"
    },
    onClick: _cache[3] || (_cache[3] = (...args) => $options.openStakers && $options.openStakers(...args))
  }, _hoisted_77)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.tvlLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_78, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_79, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      customStyle: {
        margin: '0'
      },
      color: "",
      number: _ctx.stakeCount,
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])])])])]), _createVNode(_component_i_skeleton, {
    loading: (_ctx.variableDebtTokenTotalSupplyLoading || _ctx.stableDebtTokenTotalSupplyLoading || _ctx.poolStFilBalanceLoading) && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('dashboard.UtilizationRate')) + " " + _toDisplayString((parseInt(_ctx.utilizationRate) / 100).toFixed(2)) + "% ", 1)]), _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('dashboard.liquidityReserveRatio')) + " " + _toDisplayString((parseFloat(_ctx.liquidityReserveRatio.toString()) / 100.0).toFixed(2)) + "%", 1)]), _createVNode(_component_el_tooltip, {
      "raw-content": "",
      placement: "top-end",
      effect: "light"
    }, {
      content: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('dashboard.UtilizationRate')) + " " + _toDisplayString((parseInt(_ctx.utilizationRate) / 100).toFixed(2)) + "% ", 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('dashboard.OptimalUtilizationRate')) + " " + _toDisplayString(_ctx.optimalUtilizationRateIntervalStart.toFixed(0)) + "% ~ " + _toDisplayString(_ctx.optimalUtilizationRateIntervalEnd.toFixed(0)) + "% ", 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('dashboard.maxBorrowableLiquidityAmount')) + " " + _toDisplayString($options.formatWalletFilPrice(_ctx.maxBorrowableLiquidityAmount)), 1)])]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_hoisted_86, _createElementVNode("div", {
        class: "borrow-current-progress-indicate",
        style: _normalizeStyle({
          width: (parseInt(_ctx.utilizationRate) / 100).toFixed(2) + '%'
        })
      }, null, 4), _createElementVNode("div", {
        class: "borrow-progress-indicate",
        style: _normalizeStyle({
          left: _ctx.optimalUtilizationRateIntervalStart.toFixed(2) + '%',
          width: (_ctx.optimalUtilizationRateIntervalEnd - _ctx.optimalUtilizationRateIntervalStart).toFixed(2) + '%',
          borderColor: '#6752F0'
        })
      }, null, 4), _ctx.liquidityReserveRatio > 0n ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "liquidityReserveRatio-indicate",
        style: _normalizeStyle({
          left: ((10000.0 - parseFloat(_ctx.liquidityReserveRatio.toString())) / 100.0).toFixed(2) + '%'
        })
      }, null, 4)) : _createCommentVNode("", true)])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["loading"])])])])])]), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.$t('dashboard.StakingPoolInfo')), 1), _hoisted_92]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.$t('dashboard.TotalSupply')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.supplyBalanceLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_96, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })]), _createElementVNode("div", _hoisted_97, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_98, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.externalFormatFilPrice(_ctx.supplyBalance, 6, true, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.supplyBalanceObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_99, [_createVNode(_component_ScrollNumber, {
      prefix: "$",
      class: "scroll-number-sub-title",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.supplyBalanceObj.suffix,
      number: _ctx.supplyBalanceObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_100, [_createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.$t('dashboard.dashTotalBorrowed')), 1)]), _createVNode(_component_i_skeleton, {
    loading: (_ctx.variableDebtTokenTotalSupplyLoading || _ctx.stableDebtTokenTotalSupplyLoading) && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_103, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })]), _createElementVNode("div", _hoisted_104, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_105, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.externalFormatFilPrice(_ctx.borrowBalance, 2, true, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.borrowBalanceObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_106, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-sub-title",
      prefix: "$",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.borrowBalanceObj.suffix,
      number: _ctx.borrowBalanceObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), _createVNode(_component_chart_block, {
    ref: "chartStake",
    height: "380px",
    option: $data.optionSupplyInfo,
    onChartSelect: $options.chartStakeSelect
  }, null, 8, ["option", "onChartSelect"])])])]), _createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createVNode(_component_StakeLeftChart)])]), _createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_createVNode(_component_AdCard, {
    title: _ctx.$t('dashboard.adTitle'),
    content: _ctx.$t('dashboard.adContent'),
    "btn-text": _ctx.$t('subpool.createPoolBtn'),
    onBtnClick: $options.onboarding
  }, null, 8, ["title", "content", "btn-text", "onBtnClick"])])]), _createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_createElementVNode("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t('dashboard.BorrowInfo')), 1), _hoisted_116]), _createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.$t('dashboard.Variable')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.variableDebtTokenTotalSupplyLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_120, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })]), _createElementVNode("div", _hoisted_121, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_122, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.formatWalletFilPrice(_ctx.variableDebtTokenTotalSupply, 2, true, true, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.variableDebtTokenTotalSupplyObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_123, [_createVNode(_component_ScrollNumber, {
      prefix: "$",
      class: "scroll-number-sub-title",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.variableDebtTokenTotalSupplyObj.suffix,
      number: _ctx.variableDebtTokenTotalSupplyObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]), _hoisted_124, _createElementVNode("div", _hoisted_125, [_createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.$t('dashboard.Stable')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.stableDebtTokenTotalSupplyLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_127, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })]), _createElementVNode("div", _hoisted_128, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_129, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "FIL",
      number: $options.formatWalletFilPrice(_ctx.stableDebtTokenTotalSupply, 2, true, true, false),
      h: 18
    }, null, 8, ["number"])]), _ctx.stableDebtTokenTotalSupplyObj !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_130, [_createVNode(_component_ScrollNumber, {
      prefix: "$",
      class: "scroll-number-sub-title",
      customSignStyle: {
        margin: '0 -3.5px !important'
      },
      "prefix-style": {
        margin: '0'
      },
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0'
      },
      color: "",
      unit: _ctx.stableDebtTokenTotalSupplyObj.suffix,
      number: _ctx.stableDebtTokenTotalSupplyObj.value,
      h: 14
    }, null, 8, ["customSignStyle", "unit", "number"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), _createVNode(_component_chart_block, {
    ref: "chartBorrow",
    height: "350px",
    option: $data.optionBorrowInfo,
    onChartSelect: $options.chartBorrowSelect
  }, null, 8, ["option", "onChartSelect"])])]), _createElementVNode("div", _hoisted_131, [_createElementVNode("div", _hoisted_132, [_createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, _toDisplayString(_ctx.$t('dashboard.InterestRateMode')), 1), _hoisted_135]), _createElementVNode("div", _hoisted_136, [_createElementVNode("div", _hoisted_137, [_createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.$t('dashboard.APYVariable')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.reserveDataLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_139, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_140, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "%",
      number: $options.formatPrice($options.formatUnits(_ctx.variableBorrowRate, 25), 2),
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])]), _hoisted_141, _createElementVNode("div", _hoisted_142, [_createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.$t('dashboard.APYStable')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.reserveDataLoading && !_ctx.timingFlag
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_144, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "120px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_145, [_createVNode(_component_ScrollNumber, {
      class: "scroll-number-title",
      unitStyle: {
        margin: '0 0 0 2px'
      },
      customStyle: {
        margin: '0 -1px'
      },
      color: "",
      unit: "%",
      number: $options.formatPrice($options.formatUnits(_ctx.stableBorrowRate, 25), 2),
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])])]), _createVNode(_component_chart_block, {
    ref: "chartRate",
    height: "372px",
    option: $data.optionInterestRateMode,
    onChartSelect: $options.chartRateSelect
  }, null, 8, ["option", "onChartSelect"])])])])])]);
}